export const ZOOM_RESET_LEVEL = 1;

// Tolerant comparison so float accumulation (0.25 steps, wheel/touch zoom) still counts as 100%
export const isZoomAtDefault = (zoom) => Math.abs((Number(zoom) || 0) - ZOOM_RESET_LEVEL) < 0.001;
